import ReactMarkdown from 'react-markdown'
// graphql
import { useQuery } from '@apollo/client';
import { GET_PAGE_DATA} from '../../graphql/queries';
// helmet
import { Helmet } from "react-helmet";
// components
import PageState from '../../components/Elements/PageState';
import Button from "../../components/Basics/Button";

export default function Reserven() {
  const slug = 'reserven';
  // --------- QUERY FOR THE PAGE DATA --------- //
  const { loading, error, data } = useQuery(GET_PAGE_DATA, {
    variables: { slug },
  });
  // --------- PAGE DATA --------- //
  const pageData = data?.page;
  // --------- RENDER --------- //
  return (
    <PageState loading={loading} error={error}>
      {/* head data */}
      <Helmet>
        <title>{pageData?.title}</title>
        <meta name='description' content={pageData?.pageDescription}/>
      </Helmet>
      <div className="container container--top">
        <h1 className='container__header'>Reserven</h1>
        <div className='container__header'>
          <h3>Informatie over de reserven {pageData?.season?.title}</h3>
          {pageData?.season?.bTeamCalendar ?
            <Button label='Kalender bekijken' link={pageData.season.bTeamCalendar.url} target="_blank" />
            : <Button label='Kalender bekijken (binnenkort beschikbaar)' link="#" target="_blank" />
          }
        </div>
        {pageData?.extraContent && (
          <div className='container__content'>
            <ReactMarkdown>{pageData.extraContent}</ReactMarkdown>
          </div>
        )}
      </div>
    </PageState>
  );
}
